import React from 'react';
import { Video, SoundControl, Close } from '..';
import Loading from '../Loading';
import { Controls } from './Controls';
import { sendMessageToParent } from '../../helpers/messageProxy';
import './style.css';

export class Player extends React.Component {
  static defaulProps = {
    videos: []
  };

  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      playing: true,
      soundEnabled: false,
      videoCanBePlayed: false,
    };
  }

  onCanPlay = () => {
    this.setState({ videoCanBePlayed: true });
  }

  onClickVideo = (event) => {
    const invalidTarget = event.target.tagName === 'I';
    const cannotReproduce = !this.state.videoCanBePlayed;
    if (invalidTarget || cannotReproduce) return;

    this.setState(previousState => ({
      playing: !previousState.playing
    }));
  }

  playPreviousVideo = () => {
    const isFirstItem = this.state.current === 0;
    const current = isFirstItem
      ? this.props.videos.length - 1
      : this.state.current - 1;

    this.setState({
      current,
      playing: true,
      videoCanBePlayed: false
    });
  }

  playNextVideo = () => {
    const isLastItem = this.state.current === this.props.videos.length - 1;
    const current = isLastItem ? 0 : this.state.current + 1;

    this.setState({
      current,
      playing: true,
      videoCanBePlayed: false
    });
  }

  stopVideo = () => {
    this.setState({ playing: true });
  }

  toggleVolume = () => {
    this.setState(previousState => ({
      soundEnabled: !previousState.soundEnabled
    }));
  }

  closeVideo = () => {
    sendMessageToParent({ type: 'CLOSE_VIDEO' });
  }

  render() {
    const { videos } = this.props;
    if (!videos.length) return null;

    const { current, playing, soundEnabled, videoCanBePlayed } = this.state;
    const showControls = !playing;
    const haveMoreThanOneVideo = videos.length > 1;

    return (
      <div
        className="player"
        onClick={this.onClickVideo}
      >
        <Loading active={!videoCanBePlayed} />

        <Close
          show={videoCanBePlayed}
          onClick={this.closeVideo}
        />

        <Controls
          show={showControls}
          showPrevious={haveMoreThanOneVideo}
          onPreviousClick={this.playPreviousVideo}
          onPlayClick={this.stopVideo}
          showNext={haveMoreThanOneVideo}
          onNextClick={this.playNextVideo}
        />

        <div className="sound-control">
          <SoundControl
            show={videoCanBePlayed}
            enabled={soundEnabled}
            onClick={this.toggleVolume}
          />
        </div>

        <Video
          {...videos[current]}
          playing={this.state.playing}
          soundMuted={!soundEnabled}
          onVideoEnds={this.playNextVideo}
          onCanPlay={this.onCanPlay}
          onChangeVideoOrientation={this.onChangeVideoOrientation}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Player/Player.jsx